import api from './api'

export const fetchPendingDocuments = ({ limit } = {}) =>
	api.get('/counseling/dashboard/documents-pending', {
		params: {
			limit: Number.isFinite(Number(limit)) ? Number(limit) : undefined,
		},
	})

export const markStudentDocumentsSeen = (studentId, { anchorAt } = {}) =>
	api.post(
		`/counseling/dashboard/students/${encodeURIComponent(studentId)}/documents/seen`,
		{ anchor_at: anchorAt || undefined },
	)
